// extracted by mini-css-extract-plugin
export default {"trigger":"lLR70","popover":"aArtn","popoverBottomStart":"Pj1_a","popoverRightEnd":"dowiE","popoverLeftEnd":"k1jeZ"};